import { atom } from "jotai";

export const showCommentsAtom = atom(true);
export const isAIPanelOpenAtom = atom(false);
export const isTimerOpenAtom = atom(false);
